export type TopUpAddressConfig = {
  showFirstName: boolean;
  showLastName: boolean;
  showAddressName: boolean;
  showEmail: boolean;
  showStreet: boolean;
  showTown: boolean;
  showCountryRegion: boolean;
  showPostCode: boolean;
  showMobileNumber: boolean;
};

export const topUpAddressConfigDefault = {
  showFirstName: true,
  showLastName: true,
  showAddressName: false,
  showStreet: true,
  showTown: true,
  showCountryRegion: true,
  showPostCode: true,
  showMobileNumber: true,
  showEmail: true,
};
